// 封装懒加载方法
export const lazyLoadBlocks = function (blocks, offset) {
    let loadedBlocks = [];

    function lazyLoad(blocks, offset) {
        for (let i = 0; i < blocks.length; i++) {
            let blockId = blocks[i].key
            let callback = blocks[i].callback
            let block = document.querySelector(blockId);
            if (!loadedBlocks.includes(blockId) && block?.getBoundingClientRect()?.top < window.innerHeight + offset) {
                callback()
                // 将已加载的区块添加到已加载列表
                loadedBlocks.push(blockId);
            }
        }
        // 如果所有区块都已加载，则移除滚动事件监听器
        if (loadedBlocks.length === blocks.length) {
            window.removeEventListener('scroll', throttledLazyLoad);
        }
    }
    const throttledLazyLoad = throttle(lazyLoad, 200)
    const scrollFunc = () => {
        throttledLazyLoad(blocks, offset)
    }
    window.addEventListener('scroll', scrollFunc);
    throttledLazyLoad(blocks, 0) // 初始化时就执行一次，避免文章过短页面无法scroll也就无法触发懒加载,设置offset为0，避免初始时图片还未加载高度塌陷导致一开始就加载问题
}
// 节流
function throttle(func, limit) {
    let inThrottle
    return function (...args) {
        const context = this
        if (!inThrottle) {
            func.apply(context, args)
            inThrottle = true
            setTimeout(() => inThrottle = false, limit)
        }
    }
}